

export class RfCodeModel {
    rfCode: string;

    /**
     * 
     * @param rfCode 
     */
    constructor(rfCode: string) {
        this.rfCode = rfCode
    }
}